// 列表 合作標語
import { useTranslation } from 'react-i18next';

const ListHint = () => {
    const { t } = useTranslation();

    return (
        <h4 className="text-bd4n text-black6 text-left">
            {t('HINT')}
            <a
                href="mailto:news@sounova.com"
                target="_blank"
                rel="noreferrer noopener"
                className="text-bou px-[3px] underline decoration-bou
                trans hover:text-purple hover:decoration-purple"
            >
                news@sounova.com
            </a>
        </h4>
    );
};

export default ListHint;
